<template>
  <div>
    <v-row>
      <v-col v-for="(card, index) in cardsMetrics" :key="index" cols="6" sm="4" md="3">
        <cbm-card
          :number-text="card.number"
          :title="card.title"
          :is-currency="card.isCurrency"
          :percent-text="card.percent"
          :percent-description="card.description"
          :boolean-loader="$apollo.loading"
          :tooltip="card.tooltipText"
          :percentage-tooltip="card.percentageTooltip"
          simple-card
          :unset-percentage-colors="!card.usePercentageColor"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col align="end">
        <export-email-report-dialog
          button-text="Exportar saldos de cashback"
          title="Enviar relatório de saldos de cashback"
          description="O relatório de saldos de cashback é enviado, através de um e-mail, para a caixa de entrada dos endereços de e-mail adicionados abaixo. Um arquivo CSV ou XLSX contendo todas as informações detalhadas dos pontos é enviado em anexo ao e-mail."
          :exportReportFn="exportReport"
          async
          @file-format="getFileFormat"
        />
        <filters-menu :filters="['data', 'lojas', 'produtos']" default-date="ultimosTrintaDias" hide-ecommerce-configuration />
      </v-col>
    </v-row>

    <cashback-metrics-chart :state-filters="stateFilters" />

    <cashback-metrics-table />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CashbackMetricsChart from '@/modules/mobile/cashback/views/components/CashbackMetricsChart.vue'
import CashbackMetricsTable from '@/modules/mobile/cashback/views/components/CashbackMetricsTable.vue'
import CbmCard from '@/components/CbmCard.vue'
import {
  ACTIVE_CASHBACK_METRIC,
  CUSTOMERS_WITH_CASHBACK_METRIC,
  CUSTOMERS_USING_CASHBACK_METRIC,
  CONSUMED_CASHBACK_METRIC,
  MUTATION_SEND_CASHBACK_BALANCE_ASYNC_JOB,
} from '@/modules/mobile/cashback/graphql'
import { localeString } from '@/config/helpers.js'

export default {
  name: 'CashbackMetrics',

  components: {
    FiltersMenu: () => import('@/components/FiltersMenu.vue'),
    ExportEmailReportDialog: () => import('@/components/export-email-report/ExportEmailReportDialog.vue'),
    CashbackMetricsChart,
    CashbackMetricsTable,
    CbmCard,
  },

  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    cardsMetrics() {
      return [
        {
          title: 'Cashback ativo',
          isCurrency: true,
          number: `${localeString(this.activeCashbackMetric?.value || 0, 0)}`,
          description: 'expiram esse mês',
          tooltipText:
            'Quantia total de cashback adquirido pelos consumidores que ainda não foi utilizado. Representa a soma do cashback ativo e inativo na carteira.',
          percent: `R$ ${localeString(this.activeCashbackMetric?.expires_current_month || 0, 0)}`,
        },
        {
          title: 'Clientes com cashback',
          isCurrency: false,
          number: `${localeString(this.customersWithCashbackMetric?.value || 0)}`,
          tooltipText: 'Quantidade total de clientes que possuem algum saldo em cashback pronto para ser utilizado.',
        },
        {
          title: 'Clientes que aderiram',
          isCurrency: false,
          number: `${localeString(this.customersUsingCashbackMetric?.value || 0)}`,
          description: 'novos clientes esse mês',
          tooltipText: 'Quantidade total de clientes que já compraram produtos com cashback.',
          percent: `${localeString(this.customersUsingCashbackMetric?.details || 0)}`,
        },
        {
          title: 'Cashback consumido',
          isCurrency: true,
          number: `${localeString(this.consumedCashbackMetric?.value || 0, 0)}`,
          description: 'esse mês',
          tooltipText: 'Total de cashback aplicado por consumidores em cupons feitos nas suas lojas.',
          percent: `R$ ${localeString(this.consumedCashbackMetric?.details || 0, 0)}`,
        },
      ]
    },
  },

  apollo: {
    activeCashbackMetric: {
      query: ACTIVE_CASHBACK_METRIC,
      context() {
        return {
          uri: this.$microservicesUrls['cashback'],
        }
      },
    },

    customersWithCashbackMetric: {
      query: CUSTOMERS_WITH_CASHBACK_METRIC,
      context() {
        return {
          uri: this.$microservicesUrls['cashback'],
        }
      },
    },

    customersUsingCashbackMetric: {
      query: CUSTOMERS_USING_CASHBACK_METRIC,
      context() {
        return {
          uri: this.$microservicesUrls['cashback'],
        }
      },
    },

    consumedCashbackMetric: {
      query: CONSUMED_CASHBACK_METRIC,
      context() {
        return {
          uri: this.$microservicesUrls['cashback'],
        }
      },
    },
  },
  methods: {
    getFileFormat(value) {
      this.fileFormat = value
    },
    async exportReport(emails) {
      return this.$apollo.mutate({
        mutation: MUTATION_SEND_CASHBACK_BALANCE_ASYNC_JOB,
        fetchPolicy: 'no-cache',
        variables: {
          emails,
          fileFormat: this.fileFormat,
        },
        context: {
          uri: this.$microservicesUrls['asyncJobs'],
        },
      })
    },
  },
}
</script>
